module.exports = "../dist/frontend/icons/benefits/green/notification.svg?4577b17cbf92ceb91cac40054aa79524";